export class PUUDataReq {
  constructor(
    public id: string | undefined,
    public name: string,
    public type: string,
    public password: string,
    public email: string
  ) {}
}
export class PostUpsertUserReq {
  constructor(
    public data: PUUDataReq
  ) {
  }
}
